module.exports = "/_next/static/images/fc9608fd51db91fce9153296e816aca2-product-information-md-1x.jpg";